/**
 * @author Lucas Fridez <lfridez@artionet.com>
 * @client Inelectro
 * @project webapp-scan
 * @file src\app\framework\user\UserProfile.ts
 * @copyright 2018 Artionet Web Agency
 */

export enum UserProfile_e {
    AGENCY_MANAGER = 1,
    FITTER = 2
}



// WEBPACK FOOTER //
// ./src/app/framework/user/UserProfile.ts